import { useTranslation } from 'react-i18next';

import { SectionContainer } from 'components/shared';
import { DeliveryType } from 'interfaces';

import styles from './SelectedDeliveryTypeSection.module.css';

type SelectedDeliveryTypeSectionProps = {
   selectedDeliveryType: DeliveryType;
};

const SelectedDeliveryTypeSection = ({
   selectedDeliveryType,
}: SelectedDeliveryTypeSectionProps) => {
   const { t } = useTranslation();

   return (
      <SectionContainer title={t('order_summary.delivery_type.title')}>
         <p className={styles.deliveryTypeText}>
            {t(`order_summary.delivery_type.${selectedDeliveryType}`)}
         </p>
      </SectionContainer>
   );
};

export default SelectedDeliveryTypeSection;
